import Link, { LinkProps } from 'app/components/base/Link'
import Text from 'app/components/base/Text'

export type LinkUserStoreProps = Omit<LinkProps, 'href' | 'ref'> & {
  slug?: string
}

const LinkUserStore: RFC<LinkUserStoreProps> = ({ slug, ...rest }) => {
  const link = `/store/${slug}/products`

  if (!slug) return <Text {...rest} />

  return <Link href={link} {...rest} />
}

export default LinkUserStore
